// Import all avatar images
import face1 from '../assets/avatars/Face-1.png';
import face2 from '../assets/avatars/Face-2.png';
import face from '../assets/avatars/Face.png';
import faceCo1 from '../assets/avatars/face_co (1) 4.png';
import faceCo2 from '../assets/avatars/face_co (2) 4.png';
import faceCo3 from '../assets/avatars/face_co (3) 4.png';
import faceCo4 from '../assets/avatars/face_co (4) 4.png';
import faceCo5 from '../assets/avatars/face_co (5) 4.png';
import faceCo6 from '../assets/avatars/face_co (6) 4.png';
import faceCo7 from '../assets/avatars/face_co (7) 4.png';
import faceCo8 from '../assets/avatars/face_co (8) 4.png';
import faceCo12 from '../assets/avatars/face_co (12) 4.png';
import faceCo13 from '../assets/avatars/face_co (13) 4.png';
import faceCo14 from '../assets/avatars/face_co (14) 4.png';
import faceCo15 from '../assets/avatars/face_co (15) 4.png';
import faceCo16 from '../assets/avatars/face_co (16) 4.png';
import faceCo17 from '../assets/avatars/face_co (17) 4.png';
import faceCo18 from '../assets/avatars/face_co (18) 4.png';
import faceCo19 from '../assets/avatars/face_co (19) 4.png';
import faceCo20 from '../assets/avatars/face_co (20) 4.png';
import faceCo21 from '../assets/avatars/face_co (21) 4.png';
import faceCo23 from '../assets/avatars/face_co (23) 4.png';
import faceCo24 from '../assets/avatars/face_co (24) 4.png';
import faceCo25 from '../assets/avatars/face_co (25) 4.png';
import faceCo26 from '../assets/avatars/face_co (26) 4.png';
import faceCo28 from '../assets/avatars/face_co (28) 4.png';
import faceCo29 from '../assets/avatars/face_co (29) 4.png';
import faceCo30 from '../assets/avatars/face_co (30) 5.png';
import faceCo31 from '../assets/avatars/face_co (31) 4.png';
import faceCo32 from '../assets/avatars/face_co (32) 4.png';
import faceCo33 from '../assets/avatars/face_co (33) 4.png';
import faceCo34 from '../assets/avatars/face_co (34) 4.png';
import faceCo35 from '../assets/avatars/face_co (35) 4.png';
import faceCo36 from '../assets/avatars/face_co (36) 4.png';

// Create a mapping object for easy lookup
export const avatarImageMap = {
  'Face-1.png': face1,
  'Face-2.png': face2,
  'Face.png': face,
  'face_co (1) 4.png': faceCo1,
  'face_co (2) 4.png': faceCo2,
  'face_co (3) 4.png': faceCo3,
  'face_co (4) 4.png': faceCo4,
  'face_co (5) 4.png': faceCo5,
  'face_co (6) 4.png': faceCo6,
  'face_co (7) 4.png': faceCo7,
  'face_co (8) 4.png': faceCo8,
  'face_co (12) 4.png': faceCo12,
  'face_co (13) 4.png': faceCo13,
  'face_co (14) 4.png': faceCo14,
  'face_co (15) 4.png': faceCo15,
  'face_co (16) 4.png': faceCo16,
  'face_co (17) 4.png': faceCo17,
  'face_co (18) 4.png': faceCo18,
  'face_co (19) 4.png': faceCo19,
  'face_co (20) 4.png': faceCo20,
  'face_co (21) 4.png': faceCo21,
  'face_co (23) 4.png': faceCo23,
  'face_co (24) 4.png': faceCo24,
  'face_co (25) 4.png': faceCo25,
  'face_co (26) 4.png': faceCo26,
  'face_co (28) 4.png': faceCo28,
  'face_co (29) 4.png': faceCo29,
  'face_co (30) 5.png': faceCo30,
  'face_co (31) 4.png': faceCo31,
  'face_co (32) 4.png': faceCo32,
  'face_co (33) 4.png': faceCo33,
  'face_co (34) 4.png': faceCo34,
  'face_co (35) 4.png': faceCo35,
  'face_co (36) 4.png': faceCo36,
};

// Helper function to get avatar image by filename
export const getAvatarImage = (filename) => {
  return avatarImageMap[filename] || null;
};